import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import type React from 'react';
import styled from 'styled-components';
import { StyledLink } from '../link/link';

const StyledOpenInNewIcon = styled(OpenInNewIcon)`
  height: 0.6em;
  width: 0.6em;
  vertical-align: middle;
`;

const Unbreakable = styled.span`
  white-space: nowrap;
`;

/* Here we maintain the same styling we use on our default
Link component, but use the regular anchor component in
place of our specialized routing component. */

type ExternalLinkProps = React.HTMLProps<HTMLAnchorElement>;

const StyledExternalLink: React.FC<ExternalLinkProps> = StyledLink.withComponent('a');

export function ExternalLink(props: ExternalLinkProps): JSX.Element {
  const target = props.target ?? '_blank';
  return (
    <StyledExternalLink target={target} {...props}>
      {props.children}
      {target === '_blank' && (
        <Unbreakable>
          &nbsp;
          <StyledOpenInNewIcon />
        </Unbreakable>
      )}
    </StyledExternalLink>
  );
}
